// Lightweight cross-route store for inbound keyboard navigation.
//
// The inbound list and the inbound detail live in separate route trees (unlike
// outbound, where the detail overlay is nested inside the list and shares an
// OverlayNavProvider). So we keep the currently loaded inbound ids here: the
// list (DataView.onDataLoaded) writes the rows the user actually sees — already
// filtered/sorted/paginated — and the detail page reads them to step to the
// previous/next inbound with the arrow keys.
//
// Module-level on purpose: it must survive the full-page route swap from list
// to detail, and it is only read on keypress, so it needs no reactivity.
let ids: number[] = [];

export const setInboundNavIds = (next: number[]): void => {
  ids = next;
};

export const getInboundNavIds = (): number[] => ids;
